import { StyleSheet, Text, View } from 'react-native';

import { colorPrimary, colorSemantic, fontSize, radii, spacing } from '@/theme';

const HANDLE_WIDTH = 60;
const HANDLE_HEIGHT = 4;
const HANDLE_RADIUS = 12;

export interface BottomSheetHeaderProps {
  readonly title: string;
  readonly testID?: string;
}

export const BottomSheetHeader = ({ title, testID }: BottomSheetHeaderProps) => (
  <View style={styles.container} testID={testID}>
    <View style={styles.handle} testID={testID ? `${testID}-handle` : undefined} />
    <Text accessibilityRole="header" numberOfLines={1} style={styles.title}>
      {title}
    </Text>
  </View>
);

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    backgroundColor: colorPrimary.nl0,
    borderBottomColor: colorSemantic.colorBorderNdBase,
    borderBottomWidth: 1,
    borderTopLeftRadius: radii.lg,
    borderTopRightRadius: radii.lg,
    paddingHorizontal: spacing[4],
    paddingVertical: spacing[2],
    rowGap: 3,
    width: '100%',
  },
  handle: {
    backgroundColor: colorSemantic.colorBgNlStronger,
    borderRadius: HANDLE_RADIUS,
    height: HANDLE_HEIGHT,
    width: HANDLE_WIDTH,
  },
  title: {
    color: colorSemantic.colorTextNdPrimary,
    fontSize: fontSize.lg,
    fontWeight: 'bold',
    lineHeight: 32,
    textAlign: 'center',
    width: '100%',
  },
});
